import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import ProjectDetail from './pages/ProjectDetail';
import BrochureViewer from './pages/BrochureViewer';
import LibroDeVentas from './pages/LibroDeVentas';
import Cayala from './pages/Cayala';
import Tour3D from './pages/Tour3D';
import ThemeDemo from './components/ThemeDemo';
import { setTheme, getThemeFromPath } from './utils/themeUtils';
import { initializeServiceWorker } from './utils/serviceWorker';

// Component to handle theme switching based on route
const ThemeHandler: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const themeName = getThemeFromPath(location.pathname);
    setTheme(themeName);
  }, [location.pathname]);

  return null;
};

function App() {
  // Initialize service worker
  useEffect(() => {
    initializeServiceWorker();
  }, []);

  return (
    <Router>
      <div className="App">
        <ThemeHandler />
        <Header />
        <Routes>
          <Route path="/" element={<Cayala />} />
          <Route path="/home" element={<Cayala />} />
          {/* Cayala specific route - separate structure */}
          <Route path="/cayala" element={<Cayala />} />
          <Route path="/cayala/brochure" element={<BrochureViewer />} />
          <Route path="/cayala/libro-ventas" element={<LibroDeVentas />} />
          <Route path="/cayala/tour-3d" element={<Tour3D />} />
          {/* Original project detail route - handles all projects including Cayala */}
          <Route path="/project/:projectName" element={<ProjectDetail />} />
          <Route path="/project/:projectName/brochure" element={<BrochureViewer />} />
          <Route path="/project/:projectName/libro-ventas" element={<LibroDeVentas />} />
          <Route path="/project/:projectName/tour-3d" element={<Tour3D />} />
          {/* Theme demo route */}
          <Route path="/theme-demo" element={<ThemeDemo />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
